import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Multimedium } from '@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium';
import { ApiRouteConfig } from '../../../config/api.route.config';
import { HttpClient } from '@angular/common/http';
import {FileContentsResult} from '../model/file-contents-result';

@Injectable({
  providedIn: 'root'
})
export class MultimediaService {

  constructor(private httpClient: HttpClient, private api: ApiRouteConfig) { }

  public addNewPhotoToNode(nodeId: number, file: File): Observable<Multimedium> {
    const formData: FormData = new FormData();
    formData.append('photo', file, file.name);
    return this.httpClient.post<Multimedium>(
      this.api.getRouteWithInjectedParams(this.api.BUILDING_CHECKLISTS_NODE_PHOTO, [nodeId.toString()]),
      formData);
  }

  public addNewDocumentToNode(nodeId: number, file: File): Observable<Multimedium> {
    const formData: FormData = new FormData();
    formData.append('document', file, file.name);
    return this.httpClient.post<Multimedium>(
      this.api.getRouteWithInjectedParams(this.api.BUILDING_CHECKLISTS_NODE_DOCUMENT, [nodeId.toString()]),
      formData);
  }

  public addNewVideoToNode(nodeId: number, videoFile: File, snapshotFile: File): Observable<Multimedium> {
    const formData: FormData = new FormData();
    formData.append('videoFile', videoFile, videoFile.name);

    if (snapshotFile) {
      formData.append('snapshotFile', snapshotFile, snapshotFile.name);
    }

    return this.httpClient.put<Multimedium>(
      this.api.getRouteWithInjectedParams(this.api.BUILDING_CHECKLISTS_NODE_VIDEO, [nodeId.toString()]),
      formData);
  }

  public deleteMultimediumFromNode(nodeId: number, multimediumId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(this.api.getRouteWithInjectedParams(this.api.BUILDING_CHECKLISTS_NODE_MEDIA_DELETE, [nodeId.toString(), multimediumId.toString()]));
  }

  public downloadMultimedia(multiMediaIds: number[]): Observable<FileContentsResult> {
    return this.httpClient.post<FileContentsResult>(this.api.MULTIMEDIA_DOWNLOAD, multiMediaIds);
  }

  public deleteMultimedium(multimediumId: number){
    return this.httpClient.delete<boolean>(this.api.getRouteWithInjectedParams(this.api.MULTIMEDIA_DELETE, [multimediumId.toString()]))
  }
}
